import { createReducer } from '@reduxjs/toolkit';

import { noop } from '@constants/general';

import {
  CREATE_MAPPING_FAILURE,
  CREATE_MAPPING_RESET,
  CREATE_MAPPING_START,
  CREATE_MAPPING_SUCCESS,
} from './createMapping.const';

export const initialState = {
  model: {},
  meta: {
    isSaving: false,
    errorMessage: '',
    hasError: false,
  },
};

const createMappingReducer = createReducer(initialState, builder => {
  builder
    .addCase(CREATE_MAPPING_RESET, () => initialState)
    .addCase(CREATE_MAPPING_START, state => {
      state.meta.isSaving = true;
    })
    .addCase(CREATE_MAPPING_SUCCESS, (state, { payload }) => {
      state.meta.isSaving = false;
      state.model = payload;
    })
    .addCase(CREATE_MAPPING_FAILURE, (state, { payload }) => {
      state.meta.isSaving = false;
      state.meta.errorMessage = payload;
    })
    .addDefaultCase(noop);
});

export default createMappingReducer;
